"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var __1 = require("../..");
var useLayouts_1 = __importDefault(require("./hooks/useLayouts"));
var Pip_1 = __importStar(require("./Pip"));
var VideoStream_1 = __importDefault(require("./VideoStream"));
// Note: the styles in this layout assume that their container is 'display: flex;'
//@ts-ignore
var useStyles = core_1.makeStyles(function () { return ({
    container: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
    }
}); });
function MobileLayout(props) {
    var _a, _b;
    var _c = props.muteRemotes, muteRemotes = _c === void 0 ? false : _c, _d = props.showPip, showPip = _d === void 0 ? false : _d, videoLayout = props.videoLayout, miniPlayerMode = props.miniPlayerMode;
    var _e = react_1.useState(true), presentationFocused = _e[0], setPresentationFocused = _e[1];
    var remoteStreams = __1.hooks.useRemoteStreams();
    var remoteStream = remoteStreams.find(function (s) { return !!(s === null || s === void 0 ? void 0 : s.getVideoTracks()[0]); });
    var localPrimaryStream = __1.hooks.useLocalPrimaryStream();
    var _f = __1.hooks.useMedia(), presentationLayout = _f.presentationLayout, layout = _f.layout, remotePresentationStream = _f.remotePresentationStream, localVideoMuted = _f.localVideoMuted;
    var numberOfRemoteStreams = remoteStreams.length;
    var presentationInLayout = !!remotePresentationStream && (remotePresentationStream === null || remotePresentationStream === void 0 ? void 0 : remotePresentationStream.active) &&
        presentationLayout !== __1.constants.SFU_PRES_LAYOUT_POPPEDOUT;
    var width = miniPlayerMode ? videoLayout.videoPrimary.width : (_a = videoLayout.container) === null || _a === void 0 ? void 0 : _a.width;
    var height = (_b = videoLayout.container) === null || _b === void 0 ? void 0 : _b.height;
    var styles = useLayouts_1.default({
        layout: layout,
        numberOfRemoteStreams: numberOfRemoteStreams,
        width: width,
        height: height
    }).styles;
    react_1.useEffect(function () {
        setPresentationFocused(presentationInLayout);
    }, [presentationInLayout]);
    var classes = useStyles();
    var wrapperStyle = styles(0, false)[2] || {
        height: '100%',
        position: 'relative',
        width: 'calc(var(--vw, 1vw) * 100)'
    };
    if (showPip) {
        wrapperStyle.top = 0;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        showPip && (react_1.default.createElement(Pip_1.default, { animate: false, dataTestId: 'pip-local', displayName: localPrimaryStream.displayName, elementId: 'localVideo', mirror: !localPrimaryStream.isEnvironmentFacing, pipType: Pip_1.PipType.pip, stream: localPrimaryStream.stream, videoMuted: localVideoMuted })),
        presentationInLayout && (react_1.default.createElement(Pip_1.default, { animate: false, dataTestId: 'pip-secondary', elementId: 'secondaryPip', mirror: false, pipType: Pip_1.PipType.pip, stream: presentationFocused ? remoteStream : remotePresentationStream, videoMuted: false, onClick: function () { return setPresentationFocused(!presentationFocused); } })),
        react_1.default.createElement("div", { style: wrapperStyle },
            react_1.default.createElement("div", { style: wrapperStyle, className: classes.container },
                react_1.default.createElement(VideoStream_1.default, { dataTestId: presentationFocused ? 'remote-presentation-video' : 'remote-video', elementId: 'remoteVideo', muted: muteRemotes, mediaStream: presentationFocused ? remotePresentationStream : remoteStream, style: __assign({ objectFit: 'contain' }, wrapperStyle) })))));
}
exports.default = MobileLayout;
